import { memo } from 'react';
import classNames from 'classnames';
// Import UI components
import { Dropdown } from '@geneui/components';
// Import Styles
import 'assets/scss/validatableDropdown.scss';

export interface ValidatableDropdownProps extends React.ComponentProps<typeof Dropdown> {
    wrapperClassName?: string;
    isValid?: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    errorText?: any;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
}

const ValidatableDropdown: React.FC<ValidatableDropdownProps> = (props) => {
    const { isValid = true, errorText = '', wrapperClassName = '', ...rest } = props;
    return (
        <div className={classNames({ 'crm-invalid-dropdown': !isValid }, { [wrapperClassName]: wrapperClassName })}>
            <Dropdown autocomplete="off" {...rest} />
            <p>{errorText}</p>
        </div>
    );
};

export default memo(ValidatableDropdown);
